var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5375V10.4625L0 18V14.475L9.06667 9.075L0 3.675V0L12 7.5375Z",
    fill: "#C1C1C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToRightArrow);
export default __webpack_public_path__ + "static/media/goToRightArrow.379599ea92410f77283333c53478396a.svg";
export { ForwardRef as ReactComponent };